import ABCyaPhaser from "@abcya/abcya_phaser";
import SoundAssetKeys from "./SoundAssetKeys";

/** @type {Phaser.Sound.WebAudioSound} */
let gameJingle = null;

export function createJingle(scene)
{
    gameJingle = ABCyaPhaser.Audio.createSound(scene);
}

export function playGameJingle()
{
    if (gameJingle.isPlaying) return;

    ABCyaPhaser.Audio.playSound(SoundAssetKeys._music, gameJingle, 1, true, 0);
}

export function stopGameJingle()
{
    gameJingle.stop();
}

/**
 * 
 * @param {Phaser.Scene} scene 
 */
export function musicDown(scene)
{
    scene.tweens.killTweensOf(gameJingle);
    scene.tweens.add({targets: gameJingle, duration: 250, props: {volume: 0.2}, ease: Phaser.Math.Easing.Linear});
}

/**
 * 
 * @param {Phaser.Scene} scene 
 */
 export function musicUp(scene)
 {
     scene.tweens.killTweensOf(gameJingle);
     scene.tweens.add({targets: gameJingle, duration: 250, props: {volume: 1}, ease: Phaser.Math.Easing.Linear});
 }